import "./src/stylesheets/main.scss"

const { registerLinkResolver } = require('@prismicio/gatsby-source-prismic-graphql');
const { linkResolver } = require('./src/components/06 Utilities/linkResolver');
 
registerLinkResolver(linkResolver);